<ng-container *transloco="let t">
  <footer
    class="footer bg-primary text-base-content grid grid-cols-1 place-items-center gap-4 p-4 md:grid-cols-2 md:p-10 lg:grid-cols-3"
  >
    <aside class="place-items-center">
      <img
        class="w-24 md:w-48"
        ngSrc="assets/images/logos/INC_Innovation_Center_Logo_Text_white.png"
        width="500"
        height="350"
        alt="INC Innovation Center GmbH"
        priority
      />
    </aside>

    <nav class="text-center text-white">
      <p class="mx-auto">&copy; {{ year }} INC Innovation Center GmbH</p>
      <p class="mx-auto pb-3">Campus-Boulevard 30, 52074 Aachen, Germany</p>
      <p class="mx-auto">
        <a class="link-hover link" [href]="t('footer-privacy-url')">{{
          t('footer-privacy-text')
        }}</a>
        &nbsp;
        <a class="link-hover link" [href]="t('footer-imprint-url')">{{
          t('footer-imprint-text')
        }}</a>
      </p>
    </nav>
  </footer>
</ng-container>
